import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Users = createReactComponent("Users", ["svg", defaultAttributes, [["path", {
  d: "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2",
  key: "1lcsvf"
}], ["circle", {
  cx: "9",
  cy: "7",
  r: "4",
  key: "5wextf"
}], ["path", {
  d: "M23 21v-2a4 4 0 00-3-3.87",
  key: "125eqd"
}], ["path", {
  d: "M16 3.13a4 4 0 010 7.75",
  key: "1y0zii"
}]]]);
export default Users;